<template>
    <div
        :id="id"
        class="input-slider-wrapper"
    >
        <div
            v-if="label"
            class="input-slider-label"
            :class="{ error }"
        >{{ label }}</div>
        <div
            class="input-slider"
            :class="{ error }"
        >
            <input
                v-model.number="value"
                type="range"
                :min="min"
                :max="max"
                :step="step"
                :disabled="disabled"
            />
            <div class="input-slider-value">
                <div
                    :style="{ width: ((value - min) / (max - min)) * 100 + '%' }"
                />
            </div>
        </div>
        <ErrorText
            v-if="error"
            :error="error"
        />
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import ErrorText from '../ErrorText'
import marked from '../../utilities/marked'

defineOptions({ inheritAttrs: false })

const props = defineProps({
    id: String,
    modelValue: Number,
    disabled: Boolean,
    label: String,
    initialValue: Number,
    min: Number,
    max: Number,
    step: Number,
    error: [String, Boolean],
    blockPath: Array,
})

const emit = defineEmits(['update:modelValue'])

const label = computed(() => marked(props.label))

const value = ref(props.initialValue ?? props.min)

watch(value, (val) => {
    emit('update:modelValue', val)
}, { immediate: true })

</script>

<style lang="sass" scoped>
@import './InputSlider.sass'
</style>
